module.exports = __webpack_public_path__ + "static/media/stackoverflow-logo.6a47c615.svg";


//////////////////
// WEBPACK FOOTER
// ./src/constants/social-links/stackoverflow-logo.svg
// module id = 40
// module chunks = 0